exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-tb-stregth{width:100%;border-collapse:separate;border-spacing:10px 0}.custom-td-strength{width:33%!important;padding:10px;background:#fafafa;box-shadow:0 1px 2px #00000029;border-radius:3px;opacity:1}.txt-strength{text-align:center;color:#4b2d15;font-size:13px;white-space:nowrap}.custom-img-strength{width:16px!important;height:16px!important}@media (max-width:414px){.custom-td-strength{width:98px!important}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-36d7e180","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/UserProfile/Strength.vue
// module id = 1059
// module chunks = 0